import React from "react";
import classNames from "classnames";
import { browserHistory, locationShape } from "react-router";

import Sidebar from "../components/Sidebar.react";
import Header from "../components/Header.react";
import CurrentRoleStore from "../stores/CurrentRoleStore";
import CurrentStylingStore from "../stores/CurrentStylingStore";
import CurrentOrganizationStore from "../stores/CurrentOrganizationStore";
import EulaStore from "../stores/EulaStore";
import ApplicationReadyStore from "../stores/ApplicationReadyStore";
import CurrentOrganizationIdStore from "../stores/CurrentOrganizationIdStore";
import AdminActions from "../actions/AdminActions";
import { hideZenDeskOverlay } from "../util/zendesk";
import Eula from "./Eula.react";

import { NEXT_PATH_STORAGE_KEY } from "./App.react";

function getState() {
  return {
    adminMode: CurrentRoleStore.isAdmin(),
    styling: CurrentStylingStore.getState(),
    viewerMode: CurrentRoleStore.isViewer(),
    currentOrganization: CurrentOrganizationStore.getState(),
    ready: ApplicationReadyStore.getState(),
    eulaRequired: EulaStore.eulaRequired(),
  };
}

const EulaApp = ({ theme, logo, organizationName }) => (
  <div className={classNames("app", theme)}>
    <div className="mainPage">
      <Header
        logoFile={logo}
        organizationName={organizationName}
        viewerMode={false}
      />
      <Eula />
    </div>
  </div>
);

const ViewerApp = ({ theme, logo, organizationName, children }) => (
  <div className={classNames("app", theme)}>
    <div className="mainPage">
      <Header
        logoFile={logo}
        organizationName={organizationName}
        viewerMode={true}
      />
      {children}
    </div>
  </div>
);

const UserApp = ({ theme, logo, organizationName, children }) => (
  <div className={classNames("app", theme)}>
    <Sidebar />
    <div className="mainPage">
      <Header
        logoFile={logo}
        organizationName={organizationName}
        viewerMode={false}
      />
      {children}
    </div>
  </div>
);

class MainApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    setTimeout(() => hideZenDeskOverlay());
    this.CurrentOrganizationStore = CurrentOrganizationStore.addListener(
      this._onChange
    );
    this.currentRoleSubscription = CurrentRoleStore.addListener(this._onChange);
    this.stylingSubscription = CurrentStylingStore.addListener(this._onChange);
    this.readySubscription = ApplicationReadyStore.addListener(this._onChange);
    this.eulaSubscription = EulaStore.addListener(this._onChange);
    if (CurrentOrganizationIdStore.getState()) {
      AdminActions.requestOrganizationData(
        CurrentOrganizationIdStore.getState()
      );
    } else {
      localStorage.setItem(NEXT_PATH_STORAGE_KEY, this.props.location.pathname);
      browserHistory.push("choose");
    }
  }

  componentWillUnmount() {
    this.currentRoleSubscription.remove();
    this.stylingSubscription.remove();
    this.CurrentOrganizationStore.remove();
    this.readySubscription.remove();
    this.eulaSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  renderApp() {
    const AppChrome = this.state.viewerMode ? ViewerApp : UserApp;

    if (this.state.eulaRequired) {
      return (
        <EulaApp
          theme={this.state.styling.theme}
          logo={this.state.styling.logo}
          organizationName={this.state.currentOrganization.name}
        />
      );
    }

    return (
      <AppChrome
        theme={this.state.styling.theme}
        logo={this.state.styling.logo}
        organizationName={this.state.currentOrganization.name}
      >
        {this.props.children}
      </AppChrome>
    );
  }

  render() {
    return this.state.ready && this.renderApp();
  }
}

MainApp.propTypes = {
  location: locationShape,
};

export default MainApp;
